<template>
  <el-form class="mainSearch" style="padding: 20px">
    <el-page-header
      @back="goback"
    >
      <template #content>
        <span class="text-large font-600 mr-3">{{ title }}权限设置 </span>
      </template>
    </el-page-header>
  </el-form>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding tmp">
      <el-tree
        ref="treeRef"
        :data="permissionData"
        show-checkbox
        node-key="permissionid"
        :default-expand-all="true"
        :default-checked-keys="defaultSelectPerm"
        :props="props"
      />
    <div style="text-align: center;margin-top: 20px;">
      <el-button type="danger" @click="doPermissionSave">提交</el-button>
    </div>
    </el-col>
    </el-row>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { listGroupPermissionId, saveGroupPermission } from "@/api/group";
import { listPermission } from "@/api/permission";

const props = ref({
  value: "permissionid",
  label: "name",
});

const router = useRouter();

const permissionData = ref([]);
const defaultSelectPerm = ref([]);

const total = ref(0);
const pageSize = ref(1000); //每页显示条数
const treeRef = ref();

const groupid = ref(router.currentRoute.value.params.id);
const title = ref(router.currentRoute.value.query.name);

//确认选择，提交
const doPermissionSave = () => {
  let permissionids = [
    ...treeRef.value.getHalfCheckedKeys(),
    ...treeRef.value.getCheckedKeys(),
  ];

  saveGroupPermission({ groupid: groupid.value, permissionids }).then((res) => {
    if (res.data.code) {
      ElMessage({
        message: res.data.msg,
        type: "success",
        duration: 1000
      });
      
      setTimeout(() => {
        goback()
        }, 1000);
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

//检测权限是否已选
// const checkPer = (per) => {
//   return hasPermissioned([per]);
// };

//返回
const goback = () => {
  router.go(-1);
};

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  groupid,
});

onMounted(() => {
  // getListPerm();
  getListGroupPermissionId();

  setTimeout(() => {
    getListPerm();
  }, 400);
});

//权限列表API
const getListPerm = () => {
  listPermission(queryParam.value).then((res) => {
    let data = res.data.extend.pages.list;
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    permissionData.value = permReset(data);
  });
};

//递归所有权限
const permReset = (perms) => {
  let dataTmp = [];
  perms.forEach((perm) => {
    // console.log(perm);
    perm.permissionid = perm.permissionid.toString();
    perm.parentid = perm.parentid.toString();
    dataTmp.push(perm);
    permReset(perm.children);
  });
  return dataTmp;
};

//当前组权限的权限ID列表
const getListGroupPermissionId = () => {
  listGroupPermissionId({ groupid: groupid.value }).then((res) => {
    recursiveLastChildren(res.data.extend.permissions);
  });
};

//递归取最后值给tree,设置默认值
const recursiveLastChildren = function (list) {
  list.forEach(function (row) {
    if (row.children.length > 0) {
      recursiveLastChildren(row.children);
    } else {
      defaultSelectPerm.value.push(row.permissionid.toString());
    }
  });
};

//检测权限是否存在
// const hasPermissioned = (value) => {
//   const all_permission = "*:*:*";
//   const permissions = groupPermissionNameData.value;
//   if (value && value instanceof Array && value.length > 0) {
//     const hasPermissions = permissions.some((permission) => {
//       return all_permission === permission || value.includes(permission);
//     });
//     if (!hasPermissions) {
//       return false;
//     } else {
//       return true;
//     }
//   } else {
//     throw new Error(`请设置操作权限标签值`);
//   }
// };
</script>
<style scoped>
li {
  list-style: none;
}
.firstUl {
  text-align: left;
  padding: 0;
}
.secUl {
  text-align: left;
}
.secUl li {
  display: inline-block;
  padding: 10px;
}
.tmp .el-tree-node__content {
  float: left;
}
</style>